var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconScale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .scale-1 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .scale-1, .scale-2 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "scale-1",
    d: "m10.06,27.24h1.64c1.45,0,2.62,1.17,2.62,2.62v12.52h-6.88v-12.52c0-1.45,1.17-2.62,2.62-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scale-1",
    d: "m16.94,31.28h1.64c1.45,0,2.62,1.17,2.62,2.62v8.48h-6.88v-8.48c0-1.45,1.17-2.62,2.62-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scale-1",
    d: "m23.82,22.3h1.64c1.45,0,2.62,1.17,2.62,2.62v17.46h-6.88v-17.46c0-1.45,1.17-2.62,2.62-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scale-1",
    d: "m30.7,26.34h1.64c1.45,0,2.62,1.17,2.62,2.62v13.42h-6.88v-13.42c0-1.45,1.17-2.62,2.62-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "scale-1",
    d: "m37.57,15.47h1.64c1.45,0,2.62,1.17,2.62,2.62v24.3h-6.88v-24.3c0-1.45,1.17-2.62,2.62-2.62Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "scale-1",
    x: 5,
    y: 42.38,
    width: 40,
    height: 2.59,
    rx: 1.3,
    ry: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "scale-1",
    cx: 10.88,
    cy: 18.69,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "scale-1",
    cx: 17.76,
    cy: 22.49,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "scale-1",
    cx: 24.64,
    cy: 14.13,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "scale-1",
    cx: 31.52,
    cy: 17.54,
    r: 1.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "scale-1",
    x1: 37.7,
    y1: 7.49,
    x2: 32.21,
    y2: 16.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "scale-1",
    d: "m25.83,14.72l4.5,2.23-4.5-2.23Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "scale-1",
    x1: 23.79,
    y1: 15.16,
    x2: 18.6,
    y2: 21.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "scale-1",
    d: "m12.05,19.33l4.55,2.52-4.55-2.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "scale-1",
    cx: 38.39,
    cy: 6.36,
    r: 1.33
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "scale-2",
    width: 50,
    height: 50
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScale);
export default __webpack_public_path__ + "static/media/icon-scale.8b91c9a54aa5c950b991b1df6ae0ebcd.svg";
export { ForwardRef as ReactComponent };